// extracted by mini-css-extract-plugin
export default {"o-nav-buttons":"o-nav-buttons","o-step-foooter":"o-step-foooter"};